"use client"

import { useEffect } from "react"
import { useSearchParams } from "next/navigation"
import { useUIStore } from "@/shared/stores/ui-store"

export function AuthModalHandler() {
  const setActiveModal = useUIStore((s) => s.setActiveModal)
  const searchParams = useSearchParams()

  useEffect(() => {
    const authParam = searchParams?.get("auth")
    if (authParam === "register" || authParam === "login") {
      setActiveModal(authParam)
    }
  }, [searchParams, setActiveModal])

  return null
}
